// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("/usr/local/nginx/html/other_domains/strangeworksinc/src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-about-tsx": () => import("/usr/local/nginx/html/other_domains/strangeworksinc/src/pages/about.tsx" /* webpackChunkName: "component---src-pages-about-tsx" */),
  "component---src-pages-gallery-tsx": () => import("/usr/local/nginx/html/other_domains/strangeworksinc/src/pages/gallery.tsx" /* webpackChunkName: "component---src-pages-gallery-tsx" */),
  "component---src-pages-index-tsx": () => import("/usr/local/nginx/html/other_domains/strangeworksinc/src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-rates-tsx": () => import("/usr/local/nginx/html/other_domains/strangeworksinc/src/pages/rates.tsx" /* webpackChunkName: "component---src-pages-rates-tsx" */)
}

exports.data = () => import("/usr/local/nginx/html/other_domains/strangeworksinc/.cache/data.json")

